/**
 * Created by Abner Sui on 01/22/2019.
 * Description:
 *
 * ------ maintenance history ------
 * 05/01/2019 Yoyo make the component support routing page level awa embedded component level, use smart reducer for the component
 * 05/07/2019 Yoyo when blastemail list loads 0 data, stop blastemail detail loading status
 * 05/29/2019 Yoyo set default detail loading status =false, otherwise will be true forever on global search switching tab after filtering
 */

import { Component, OnInit, AfterViewInit, OnDestroy, HostListener, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select, createSelector } from '@ngrx/store';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { take, map, switchMap, filter, first } from 'rxjs/operators';

import { AppState, smartSelector } from '../../../redux';
import { QueryInfo, BlastEmailListConfig, SortInfo, BlastemailRefinebyConfig } from './blastemail.model';
import { BlastEmailViewActionTypes, BlastEmailViewBlastEmailListActionTypes, BlastEmailViewSetSortInfo, BlastEmailViewSetKeyWord } from '../../../redux/actions/blastemail-view.actions';
import { KeywordSearchConfig } from '../../../widgets/keyword-search/keyword-search.component';
import { getBlastEmailListItemsState, getActionMessageState, getKeywordState, getSortInfoState } from '../../../redux/reducers/blastemail-view.reducer';
import { BlastEmailDetailConfig, BlastEmailDetailActions } from '../../../components/blastemail-detail/blastemail-detail.view-model';
import { StoreQuerierService } from '../../../services/store-querier.service';
import { ScreenActionTypes } from '../../../redux/actions/screen.actions';
import { fullEntityTypeSelector } from '../../../redux/reducers/entity-type.reducer';
import { fullEntryTypeSelector } from '../../../redux/reducers/entry-type.reducer';
import { lastActionSelector, lastCustomActionSelector } from '../../../redux/reducers/action-history.reducer';

import { DataList } from '../../../tamalelibs/models/data-list.model';
import { BlastEmail } from '../../../tamalelibs/models/blastemail.model';
import { CREATE_NOTE_SUCCESS, CREATE_DRAFT_SUCCESS } from '../../../tamalelibs/redux/note.actions';
import { toplistView } from '../../../components/research-layout/research-layout.data';
import { TemplateService } from '../../../tamalelibs/services/template.service';
import { NoteBodyHtmlMetadatas } from '../../../tamalelibs/constants/business.constants';

import { ToastService } from '../../../widgets/toast/toast.service';
import { NoteDialogOpenOptions, NoteDialogType } from '../../../components/note-dialog/note-dialog.model';
import { NoteDialogService } from '../../../components/note-dialog/note-dialog.service';
import { Contact } from '../../../tamalelibs/models/contact.model';
import { ContactViewModel } from '../../../tamalelibs/components/contact.view-model';
import { BlastEmailConfig, BlastEmailConfigActionTypes, BlastEmailConfigFeedback, BlastEmailConfigFeedbackTypes } from './blastemail.model';
import { WebTemplateViewModel } from '../../../components/template/template-web.view-model';
import { StringHelperService } from '../../../tamalelibs/services/string-helper.service';
import { CREATE_CONTACT_SUCCESS } from '../../../tamalelibs/redux/app.actions';
import { NotificationStyles, NotificationOptions } from '../../../widgets/notification/notification.model';
import { businessConstants } from '../../../constants/business.constants';
import { ContactTemplateService } from '../../../components/contact-dialog-new/contact-template.service';
import { ContactTemplateOpenOptions, ContactTemplateType } from '../../../components/contact-dialog-new/contact-dialog.model';
import { EmailDetail } from '../../../tamalelibs/models/job-function';

@Component({
    selector: 'tam-blastemail',
    templateUrl: './blastemail.component.html',
    styleUrls: ['./blastemail.component.scss'],
    providers: [WebTemplateViewModel]
})
export class BlastEmailComponent implements OnInit, AfterViewInit, OnDestroy {
    // tslint:disable-next-line: no-input-rename
    @Input('config') config: BlastEmailConfig;
    isPageLoading = false;
    isBlastEmailDetailLoading = false;
    keywordSearchConfig: KeywordSearchConfig = new KeywordSearchConfig();
    blastEmailListConfig: BlastEmailListConfig;
    blastEmailListTotalCount: number;
    refineByShow = true;
    sortChangeSubject: Subject<any> = new Subject();
    sortInfo: any = {
        sortBy: 'time',
        sortOrder: 'desc',
    };
    blastEmailDetailConfig: BlastEmailDetailConfig = new BlastEmailDetailConfig();
    refinebyConfig: BlastemailRefinebyConfig;
    toplistView: any;

    private _destroySubscriptions: Array<Subscription> = [];
    private _queryInfo: QueryInfo = new QueryInfo();
    private _selectedBlastEmail;
    private _isBlastEmailFastCreateContact = false;
    private _isBlastEmailCreateContact = false;
    private _actionPrefix: { name: string, value: string } = { name: null, value: null };

    constructor(
        private _store: Store<AppState>,
        private _storeQuerier: StoreQuerierService,
        private _route: ActivatedRoute,
        private _templateService: TemplateService,
        private _contactViewModel: ContactViewModel,
        private _noteTemplatePageViewModel: WebTemplateViewModel,
        private _toast: ToastService,
        private _noteDialogService: NoteDialogService,
        private _contactTemplateService: ContactTemplateService,
    ) {
    }

    ngOnInit() {
        this.initPageOrComponent();
        this.initLayout();
        this.initComponent();
        this.isPageLoading = true;
    }

    ngAfterViewInit() {
        this.initPage();
    }

    ngOnDestroy() {
        this.destroyComponent();
    }

    initPageOrComponent() {
        if (this.config) {
            // embedded mode
            this._destroySubscriptions.push(
                this.config.actionSubject.subscribe(action => {
                    if (action.type === BlastEmailConfigActionTypes.FILTER) {
                        // set searchbox
                        this.keywordSearchConfig.actions$.next({
                            type: 'SET',
                            payload: action.payload
                        });
                    }
                }),
            );
            this._actionPrefix.name = this.config.actionKeyName;
            this._actionPrefix.value = this.config.instanceId;
        } else {
            // ngrx store is using simple reducer for this workflow, so set prefix as null
            this.config = new BlastEmailConfig('prefix', 'EmailDigestPage');
            this._actionPrefix.name = null;
            this._actionPrefix.value = null;

            const currentPageInfo: any = {
                url: this._route.snapshot.url,
                name: 'Livewire',
                type: 'CREATE_BLASTEMAIL',
                screenType: businessConstants.screenType.livewire
            };
            this._store.dispatch({
                type: ScreenActionTypes.SET_VALUE,
                payload: currentPageInfo
            });
        }
    }

    initComponent() {
        this.blastEmailDetailConfig.keywordStoreSelector = getKeywordState;
        this.blastEmailDetailConfig.messageStoreSelector = getActionMessageState;
        this.blastEmailDetailConfig.prefix = this._actionPrefix.name;
        this.blastEmailDetailConfig.instanceId = this._actionPrefix.value;

        this.blastEmailListConfig = new BlastEmailListConfig(this._actionPrefix.name, this._actionPrefix.value);
        this.refinebyConfig = new BlastemailRefinebyConfig(this._actionPrefix.name, this._actionPrefix.value);

        this._destroySubscriptions.push(
            this.keywordSearchConfig.events$.subscribe(action => this._onSubscribeKeywordSearchEvents(action)),
            this.blastEmailListConfig.events$.subscribe(action => this._onSubcribeBlastEmailListEvents(action)),
            this.refinebyConfig.events$.subscribe(action => this._onSubscribeRefinebyEvents(action)),
            this._store.pipe(
                select(this._prepareStoreSelector(getBlastEmailListItemsState, smartSelector(this._actionPrefix.value, 'blastEmailReducer'))),
                filter(data => data),
            ).subscribe(items => this._onSubscribeBlastEmailListItem(items)),
            this._store.pipe(
                select(lastCustomActionSelector)
            ).subscribe(action => this._onSubscribeActionMessage(action))
        );
    }

    initCollapse(width: number) {
        if (width >= 1024) {
            this.refineByShow = true;
        } else {
            this.refineByShow = false;
        }
    }


    initLayout() {
        this.initCollapse(window.innerWidth);
        this.toplistView = Object.assign({}, toplistView);
        this.initWidth();
    }

    initWidth() {
        if (this.refineByShow) {
            this.toplistView.previewWidth = toplistView.previewWidth;
        } else {
            this.toplistView.previewWidth = toplistView.collapsedpreviewWidth;
        }
    }

    initPage() {
        this.isPageLoading = true;
        const constantDataReadySelector = createSelector(
            fullEntityTypeSelector,
            fullEntryTypeSelector,
            (state: AppState) => state.relationshipType,
            (allEntityTypes, allEntryTypes, allRelationshipTypes) => {
                if (allEntityTypes && allEntityTypes.length > 0 &&
                    allEntryTypes && allEntryTypes.length > 0 &&
                    allRelationshipTypes && allRelationshipTypes.length > 0) {
                    return true;
                } else {
                    return false;
                }
            }
        );
        this._store.pipe(
            select(constantDataReadySelector),
            filter(isReady => isReady),
            map(() => {
                this._initializeStore();
                this._prepareQueryInfo();
            }),
            switchMap(() => {
                this._triggerDataLoad();
                return this._store.pipe(
                    select(lastActionSelector),
                    filter(action => action === BlastEmailViewBlastEmailListActionTypes.RELOAD_SUCCESS)
                );
            }),
            take(1)
        ).subscribe(() => {
            this.isPageLoading = false;
        });
    }

    destroyComponent() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    collapse() {
        this.refineByShow = !this.refineByShow;
    }

    collapsedChange(e) {
        if (e.collapsed) {
            this.toplistView.previewWidth = e.collapsedComponentSize + e.sizes[e.sizes.length - 1];
        } else {
            this.toplistView.previewWidth = e.sizes[e.sizes.length - 1] - e.collapsedComponentSize;
        }

        this._store.dispatch({
            type: BlastEmailViewBlastEmailListActionTypes.SET_LAYOUT_COLLAPSE,
            payload: !this.refineByShow
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(e) {
        this.initCollapse(e.target.innerWidth);
    }

    onClickQuickDeposit(data) {
        this._saveNote(data);
    }

    onClickNormalDeposit(data) {
        this._createNote(data);
    }

    onClickAddContact(data) {
        this._selectedBlastEmail = data;
        this._isBlastEmailCreateContact = true;
        this._isBlastEmailFastCreateContact = false;
        this._showNewContactDialog(this._selectedBlastEmail);
    }

    onClickQuickAddContact(data) {
        this._selectedBlastEmail = data;
        this._isBlastEmailFastCreateContact = true;
        this._isBlastEmailCreateContact = false;
        const contact: Contact = new Contact();
        contact.firstName = this._selectedBlastEmail.fromPersonName;
        if (!contact.firstName || contact.firstName.indexOf(',') > -1) {
            this._toast.notify({
                message: 'name contains invalid characters, please use Create Contact.',
                style: NotificationStyles.Error,
            });
        } else {
            contact.primaryEmail = this._selectedBlastEmail.fromEmailAddress;
            const email = new EmailDetail();
            email.name = 'Work';
            email.address = this._selectedBlastEmail.fromEmailAddress;
            email.primaryEmail = true;
            contact.webEmail.push(email);
            this._contactViewModel.createContact(contact);
        }
    }

    refresh(event) {
        this.refinebyConfig.actions$.next({
            type: 'RELOAD',
            payload: this._queryInfo
        });
        this.blastEmailListConfig.actions$.next({
            type: 'RELOAD',
            payload: this._queryInfo
        });
    }

    private _createNote(data: BlastEmail) {
        const _noteOption = new NoteDialogOpenOptions();
        _noteOption.entryId = businessConstants.EntryTypes.Deposited_Blast_Email_Id;
        _noteOption.openType = NoteDialogType.CreateNote;
        _noteOption.minimizable = true;
        _noteOption.blastEmail = data;

        if (data != null) {
            this._noteDialogService.dialogOpen$.next(_noteOption);
        }

    }

    private _initializeStore() {
        this._store.dispatch(
            new BlastEmailViewSetSortInfo(
                new SortInfo(),
                this._actionPrefix.name,
                this._actionPrefix.value
            )
        );
        this._store.dispatch(
            new BlastEmailViewSetKeyWord(
                '',
                this._actionPrefix.name,
                this._actionPrefix.value
            )
        );
    }

    private _onSubscribeActionMessage(action) {
        if (action.type === BlastEmailViewActionTypes.GET_BLASTEMAIL_BODY) {
            this.isBlastEmailDetailLoading = true;
        } else if (action.type === BlastEmailViewActionTypes.GET_BLASTEMAIL_BODY_SUCCESS) {
            this.isBlastEmailDetailLoading = false;
        } else if (action.type === CREATE_NOTE_SUCCESS || action.type === CREATE_CONTACT_SUCCESS) {
            this._getContactInfo(action.payload);
        } else if (action.type === BlastEmailViewBlastEmailListActionTypes.DELETE_BLASTEMAIL_SUCESS) {
            this._toast.notify({
                message: 'Email(s) successfully deleted.',
                style: NotificationStyles.Success,
            });
            this._triggerDataLoad();
        }
    }

    private _onSubscribeKeywordSearchEvents(action) {
        if (action.type === 'CHANGE') {
            this.keywordSearchConfig.keyword = action.payload.state;
            this._queryInfo.searchText = action.payload.data;
            this.refinebyConfig.actions$.next({
                type: 'RELOAD',
                payload: this._queryInfo
            });
            this.blastEmailListConfig.actions$.next({
                type: 'RELOAD',
                payload: this._queryInfo
            });
            this._store.dispatch(
                new BlastEmailViewSetKeyWord(
                    action.payload.state,
                    this._actionPrefix.name,
                    this._actionPrefix.value
                )
            );
        }
    }

    private _onSubcribeBlastEmailListEvents(event) {
        if (event.type === 'SORTCHANGEED') {
            this.sortInfo = event.payload;
            this._store.dispatch(
                new BlastEmailViewSetSortInfo(
                    {
                        sortBy: event.payload.sortBy,
                        sortOrder: event.payload.sortOrder
                    },
                    this._actionPrefix.name,
                    this._actionPrefix.value
                )
            );
        } else if (event.type === 'DOUBLE_CLICK' || event.type === 'MAXIMIZE') {
            this.blastEmailDetailConfig.actions$.next({
                type: BlastEmailDetailActions.TOGGLE_MAXIMIZE,
                payload: true
            });
        } else if (event.type === 'READY') {
            this.config.feedbackSubject.next(new BlastEmailConfigFeedback(BlastEmailConfigFeedbackTypes.VIEW_READY, null));
            if (event.payload === false) {
                // list no record, set detail to unselected
                this.isBlastEmailDetailLoading = false;
                this.blastEmailDetailConfig.actions$.next({
                    type: BlastEmailDetailActions.CLEAR,
                    payload: null
                });
            }
        }
    }

    private _onSubscribeBlastEmailListItem(items: DataList<BlastEmail>) {
        this.blastEmailListTotalCount = items.totalCount ? items.totalCount : 0;
    }

    /**
     * send toast only when it's fast create contact
     * @param contact
     */
    private _getContactInfo(contact: Contact) {
        if (contact) {
            if (this._isBlastEmailFastCreateContact) {
                if (contact.shortName) {
                    const successMessage = 'Contact ' + contact.shortName + ' successfully created.';
                    const _successToast: NotificationOptions = {
                        message: successMessage,
                        style: NotificationStyles.Success
                    };

                    this._toast.notify(_successToast);
                    this._triggerDataLoad();
                }
            } else if (this._isBlastEmailCreateContact) {
                this._triggerDataLoad();
            }
        } else {
            this._triggerDataLoad();
        }
    }

    private _onSubscribeRefinebyEvents(action) {
        if (action.type === 'UPDATE') {
            this._queryInfo.categoryFilter = action.payload.categoryFilter;
            this._queryInfo.category = action.payload.category;
            this.refinebyConfig.actions$.next({
                type: 'UPDATE',
                payload: this._queryInfo
            });
            this.blastEmailListConfig.actions$.next({
                type: 'RELOAD',
                payload: this._queryInfo
            });
        } else if (action.type === 'LOAD_REFINEBY') {
            this._queryInfo.categoryFilter = action.payload.categoryFilter;
            this._queryInfo.category = action.payload.category;
            this.refinebyConfig.actions$.next({
                type: 'RELOAD',
                payload: this._queryInfo
            });
        } else if (action.type === 'RELOAD') {
            this._queryInfo.categoryFilter = action.payload.categoryFilter;
            this._queryInfo.category = action.payload.category;
            this.refinebyConfig.actions$.next({
                type: 'RELOAD',
                payload: this._queryInfo
            });
            this.blastEmailListConfig.actions$.next({
                type: 'RELOAD',
                payload: this._queryInfo
            });
        }
    }

    private _prepareQueryInfo() {
        this.sortInfo = this._storeQuerier.queryBySelector(this._prepareStoreSelector(getSortInfoState, smartSelector(this._actionPrefix.value, 'blastEmailReducer')));
        this._queryInfo.sortBy = this.sortInfo.sortBy;
        this._queryInfo.sortOrder = this.sortInfo.sortOrder;
        if (this.config.keyword) {
            // same logic in keyword-search.component
            this._queryInfo.searchText = StringHelperService.escapeSearchString(this.config.keyword);
            this._store.dispatch(
                new BlastEmailViewSetKeyWord(
                    this.config.keyword,
                    this._actionPrefix.name,
                    this._actionPrefix.value
                )
            );
        }
    }

    private _saveNote(blastEmail: BlastEmail) {
        let noteBody = '';
        if (blastEmail.body) {
            noteBody = blastEmail.body;
        } else {
            noteBody = NoteBodyHtmlMetadatas.fullHtml;
        }
        const formData = {
            body: noteBody,
            keepdoc: false,
        };
        const params = this._templateService.buildEntryTemplateParamsfromBlastEmail(blastEmail, businessConstants.EntryTypes.Deposited_Blast_Email_Id);
        this._noteTemplatePageViewModel.createNote(params, formData);
        const tempSubscription = this._store.pipe(
            select(lastActionSelector),
            filter(type => type === CREATE_NOTE_SUCCESS || type === CREATE_DRAFT_SUCCESS),
        ).subscribe(type => {
            const toastMsg = type === CREATE_NOTE_SUCCESS ? 'Note successfully created.' : 'Draft successfully created.';
            this._noteTemplatePageViewModel.cleanTemplateMsg();
            this._toast.notify({
                style: NotificationStyles.Success,
                message: toastMsg,
            });
            tempSubscription.unsubscribe();
        });
    }

    private _showNewContactDialog(data: BlastEmail) {
        const _contactDialogOpenOptions = new ContactTemplateOpenOptions();
        _contactDialogOpenOptions.contact = new Contact();
        _contactDialogOpenOptions.openType = ContactTemplateType.NewContact;
        if (data.fromPersonName) {
            const blastemailName = data.fromPersonName.trim();
            if (blastemailName.indexOf(' ') === -1) {
                _contactDialogOpenOptions.contact.name = data.fromPersonName;
            } else {
                const spaceIndex = blastemailName.indexOf(' ');
                let firstName = blastemailName.substring(0, spaceIndex);
                if (firstName.lastIndexOf(',')) {
                    firstName = firstName.substring(0, firstName.length - 1);
                }
                const lastName = blastemailName.substring(spaceIndex + 1, blastemailName.length);
                _contactDialogOpenOptions.contact.name = firstName;
                _contactDialogOpenOptions.contact.lastName = lastName;
            }
        }
        _contactDialogOpenOptions.contact.primaryEmail = data.fromEmailAddress;
        _contactDialogOpenOptions.isBlastEmail = true;
        this._contactTemplateService.dialogOpen$.next(_contactDialogOpenOptions);
    }


    private _triggerDataLoad() {
        this.refinebyConfig.actions$.next({
            type: 'RELOAD',
            payload: this._queryInfo
        });
        this.blastEmailListConfig.actions$.next({
            type: 'RELOAD',
            payload: this._queryInfo
        });
    }

    private _prepareStoreSelector(selector, smartSelectorParam) {
        return (state) => {
            return selector(smartSelectorParam(state));
        };
    }

}
